import React from "react";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import useValidationSchemaInfoPersoUpdate, { InfoPersoUpdate } from "src/pages/infoperso/infoperso/useValidationSchemaInfoPersoUpdate";
import { fetchUser, setPersonalInfoUpdate } from "src/app/api/AccountApi";
import { useAppState } from "src/app/state/StateProvider";
import InfoPersoUpdateFormContent from "src/pages/infoperso/infoperso/InfoPersoUpdateFormContent";

export type InfoPersoUpdateFormProps = {
  readOnly: boolean;
};


const InfoPersoUpdateForm = ({ readOnly }: InfoPersoUpdateFormProps) => {
  const [{ user }] = useAppState();
  const [, dispatch] = useAppState();

  const validationSchema = useValidationSchemaInfoPersoUpdate();

  const initialValues = {
    title: user!.title,
    firstName: user!.firstName,
    lastName: user!.lastName,
    birthdate: user!.birthdate,
    telephonePro: user!.telephonePro
  } as InfoPersoUpdate;

  const submitSuccessHandler = () => {
    fetchUser().then(result => {
      dispatch({ type: "setUser", payload: result });
    });
  };

  return (
    <AppFormik
      enableReinitialize
      initialValues={initialValues}
      submitFormAPI={(values: InfoPersoUpdate) => setPersonalInfoUpdate(values)}
      submitSuccessHandler={submitSuccessHandler}
      validationSchema={validationSchema}
    >
      <InfoPersoUpdateFormContent readOnly={readOnly}/>
    </AppFormik>
  );
};

export default InfoPersoUpdateForm;